export default "__VITE_ASSET__CDKADqOf__"